<template>
	<div class="form-mdfpwd">

		<el-form ref="form" :model="form" label-width="">
			<div class="pwdhead">
				<span class="pwdtitle">{{ThisActive.divName}}</span>
				<div class="closediv" @click="close"><span class="close"></span></div>
				<!--<span class="history-data" @click="attrChoice()">历史数据</span>-->
			</div>
			<div class="attr_body" v-if="ShowHTMLForType=='Divspan'">
				<div class="overAuto">
					<div class="data-lab clearfix" v-for="(item,index) in dataBlock">
						<div class="box_name">{{item.name}}</div>
						<div class="box_nameDevice"> / {{item.DeviceName}} : </div>
						<div class="box_content clearfix" v-if="item.type == 'int' || item.type == 'float' || item.type == 'double'">
							<div class="content_config" @click="ShowEdit(item,'Divspan')" v-if="item.accessMode=='rw'">设定</div>
							<div class="content_value" :style="{'color':item.colorTip}">{{item.value}}&nbsp;{{item.unit}}</div>
						</div>
						<div class="box_content clearfix" v-if="item.type == 'bool'">
							<div class="content_Mark" v-for="(itemData,index) in item.selectData" :class="{'active': itemData.mark}" @click="ChangeAttrStateBool(item.DeviceCode,item.id,itemData.id)">{{itemData.name}}</div>
						</div>
						<div class="box_content clearfix" v-if="item.type == 'enum'">
							<el-select popper-class="el-attrDiy" v-model="item.value" filterable placeholder="请选择" @change="(val)=>ChangeAttrStateEnum(val,item)">
								<el-option v-for="(item,index) in item.selectData" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</div>
					</div>
				</div>
			</div>
			
			<div class="attr_body" v-if="ShowHTMLForType=='img'">
				<div class="overAuto">
					<div class="data-lab clearfix" v-for="(item,index) in dataBlock">
						<div class="box_name_Img">{{item.name}} : </div>
						<div class="box_content clearfix" v-if="item.dataType.type == 'int' || item.dataType.type == 'float' || item.dataType.type == 'double'">
							<div class="content_config" @click="ShowEdit(item,'img')" v-if="item.accessMode=='rw'">设定</div>
							<div class="content_value" :style="{'color':item.colorTip}">{{item.value}}&nbsp;{{item.unit}}</div>
						</div>
						<div class="box_content clearfix" v-if="item.dataType.type == 'bool'">
							<div class="content_Mark" v-for="(itemData,index) in item.selectData" :class="{'active': itemData.mark}" @click="ChangeAttrImgBool(item.identifier,itemData.id)">{{itemData.name}}</div>
						</div>
						<div class="box_content clearfix" v-if="item.dataType.type == 'enum'">
							<el-select popper-class="el-attrDiy" v-model="item.value" filterable placeholder="请选择" @change="(val)=>ChangeAttrImgEnum(item.identifier,val)">
								<el-option v-for="(item,index) in item.selectData" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</div>
					</div>
				</div>
			</div>
			<button type="button" @click="close()" class="ely-button closeto"><span>关闭</span></button>
		</el-form>

		<mdfClassify :companyId='companyId'  :ref="attr"></mdfClassify>
		<!--<attrChoice :companyId='companyId'  :ref="attrTwo"></attrChoice>-->
	</div>
</template>

<script>
	import mdfClassify from './MdfClassifyCan.vue'
//	import attrChoice from './attrChoice.vue'
	export default {
		name: 'mdfpwd',
		props: {
			companyId: {
				type: Number,
				request: true
			}
		},
		data() {
			return {
				attr: 'mdfClassify',
				attrTwo: 'attrChoice',
				
				form: {},
				index: null,//用于关闭相应按钮
				ThisActive: {},

				ShowHTMLForType: '',//展示相应类型的html内容

				//属性看板
				dataBlock: [],
				//存放物模型字段
				PropertyValue: [],
				
				//测试字段
				ThisActiveMark: false,
				colorId: 1,
				conduitColorOptions: [{
					id: 1,
					name: '灰色',
				}, {
					id: 2,
					name: '红色',
				}, {
					id: 3,
					name: '蓝色',
				}],
			}
		},
		components: {
			mdfClassify
		},
		methods: {
			//展开页面 绑定值
			binding(item) {
				this.ThisActive = item;
				this.index = item.index;
				this.dataBlock = [];
				//console.log(this.ThisActive.DeviceMoth)
				
				if(this.ThisActive.type == 'Divspan'){
					this.ShowHTMLForType = 'Divspan';//设置当前显示html内容
					this.dataBlockPush();
				}else if(this.ThisActive.type == 'img'){
					this.ShowHTMLForType = 'img';//设置当前显示html内容
					this.dataBlock = this.ThisActive.DeviceAllAttrList;
					for(let attrData of this.dataBlock){
						if(attrData.dataType.type == 'int'){
							let value = Number(attrData.value);
							attrData.colorTip = '#282828';
							if(attrData.dataType.errorDown != null){
								let errorDown = Number(attrData.dataType.errorDown);
								if(value<=errorDown){
									attrData.colorTip = '#FF7E00';
								}
							}
							if(attrData.dataType.errorUp != null){
								let errorUp = Number(attrData.dataType.errorUp);
								if(value>=errorUp){
									attrData.colorTip = '#FF7E00';
								}
							}
							if(attrData.dataType.warnDown != null){
								let warnDown = Number(attrData.dataType.warnDown);
								if(value<=warnDown){
									attrData.colorTip = '#FF0000';
								}
							}
							if(attrData.dataType.warnUp != null){
								let warnUp = Number(attrData.dataType.warnUp);
								if(value<=warnUp){
									attrData.colorTip = '#FF0000';
								}
							}
						}else if(attrData.dataType.type == 'enum' || attrData.dataType.type == 'bool'){
							attrData.selectData = [];
							Object.keys(attrData.dataType.specs).forEach(function(key){
                                let devObj ={};
                                devObj.id = key;
                                if(attrData.value == devObj.id){
                                	devObj.mark = true
                                }else{
                                	devObj.mark = false
                                }
                                devObj.name = attrData.dataType.specs[key];
                                attrData.selectData.push(devObj);
                            });
						}
					}
				}
			},
			ChangeAttrImgEnum(attrId,value){
				let ThisActive = this.ThisActive;
				let obj = {
					deviceCode: ThisActive.DeviceCode,	
					property: attrId,
					value: value,
					companyId: this.companyId
				};
				this.post('/Device/setPropertyValue',obj).then((res)=>{
	                if(res.success){
	                    this.$message({
	                        message: '修改属性成功',
					        customClass: 'backMessage',
	                        type: 'success'
	                    });
	                    for(let data of this.dataBlock){
	                    	if(data.id == attrId){
	                    		for(let selectData of data.selectData){
	                    			selectData.mark = false;
	                    			if(selectData.id == value){
	                    				selectData.mark = true;
	                    			}
	                    		}
	                    	}
	                    }
	                    this.$forceUpdate()/*强制刷新 略略略*/
	                }else{
	                    this.$message({
	                        message: `修改属性失败:${res.message}`,
					        customClass: 'backMessage',
	                        type: 'warning'
	                    });
	                }
	            })
			},
			ChangeAttrImgBool(attrId,value){
				let ThisActive = this.ThisActive;
				let obj = {
					deviceCode: ThisActive.DeviceCode,	
					property: attrId,
					value: value,
					companyId: this.companyId
				};
				this.post('/Device/setPropertyValue',obj).then((res)=>{
	                if(res.success){
	                    this.$message({
	                        message: '修改属性成功',
					        customClass: 'backMessage',
	                        type: 'success'
	                    });
	                    for(let data of this.dataBlock){
	                    	if(data.identifier == attrId){
	                    		for(let selectData of data.selectData){
	                    			selectData.mark = false;
	                    			if(selectData.id == value){
	                    				selectData.mark = true;
	                    			}
	                    		}
	                    	}
	                    }
	                    this.$forceUpdate()/*强制刷新 略略略*/
	                }else{
	                    this.$message({
	                        message: `修改属性失败:${res.message}`,
					        customClass: 'backMessage',
	                        type: 'warning'
	                    });
	                }
	            })
			},
			ChangeAttrStateEnum(val,item) {
				let obj = {
					deviceCode: item.DeviceCode,	
					property: item.id,
					value: val,
					companyId: this.companyId
				};
				this.post('/Device/setPropertyValue',obj).then((res)=>{
	                if(res.success){
	                    this.$message({
	                        message: '修改属性成功',
					        customClass: 'backMessage',
	                        type: 'success'
	                    });
	                    for(let data of this.dataBlock){
	                    	if(data.identifier == item.id){
	                    		for(let selectData of data.selectData){
	                    			selectData.mark = false;
	                    			if(selectData.id == value){
	                    				selectData.mark = true;
	                    			}
	                    		}
	                    	}
	                    }
	                    this.$forceUpdate()/*强制刷新 略略略*/
	                }else{
	                    this.$message({
	                        message: `修改属性失败:${res.message}`,
					        customClass: 'backMessage',
	                        type: 'warning'
	                    });
	                }
	            })
			},
			ChangeAttrStateBool(DeviceCode,attrId,value) {
//				console.log(DeviceId,attrId,value)
				let obj = {
					deviceCode: DeviceCode,	
					property: attrId,
					value: value,
					companyId: this.companyId
				};
				this.post('/Device/setPropertyValue',obj).then((res)=>{
	                if(res.success){
	                    this.$message({
	                        message: '修改属性成功',
					        customClass: 'backMessage',
	                        type: 'success'
	                    });
	                    for(let data of this.dataBlock){
	                    	if(data.id == attrId){
	                    		for(let selectData of data.selectData){
	                    			selectData.mark = false;
	                    			if(selectData.id == value){
	                    				selectData.mark = true;
	                    			}
	                    		}
	                    	}
	                    }
	                    this.$forceUpdate()/*强制刷新 略略略*/
	                }else{
	                    this.$message({
	                        message: `修改属性失败:${res.message}`,
					        customClass: 'backMessage',
	                        type: 'warning'
	                    });
	                }
	            })
			},
			//更新所选属性的值
			AttrDataUpdata(id,val,type){
				if(type == 'Divspan'){
					for(let data of this.dataBlock){
						if(data.id == id){
							data.value = val;
							data.colorTip = '#282828';
							let value = Number(val)
							if(data.dataType.errorDown != null){
								let errorDown = Number(data.dataType.errorDown);
								if(value<=errorDown){
									data.colorTip = '#FF7E00';
								}
							}
							if(data.dataType.errorUp != null){
								let errorUp = Number(data.dataType.errorUp);
								if(value>=errorUp){
									data.colorTip = '#FF7E00';
								}
							}
							if(data.dataType.warnDown != null){
								let warnDown = Number(data.dataType.warnDown);
								if(value<=warnDown){
									data.colorTip = '#FF0000';
								}
							}
							if(data.dataType.warnUp != null){
								let warnUp = Number(data.dataType.warnUp);
								if(value<=warnUp){
									data.colorTip = '#FF0000';
								}
							}
						}
					}
				}else{
					for(let data of this.dataBlock){
						if(data.identifier == id){
							data.value = val;
							data.colorTip = '#282828';
							let value = Number(val)
							if(data.dataType.errorDown != null){
								let errorDown = Number(data.dataType.errorDown);
								if(value<=errorDown){
									data.colorTip = '#FF7E00';
								}
							}
							if(data.dataType.errorUp != null){
								let errorUp = Number(data.dataType.errorUp);
								if(value>=errorUp){
									data.colorTip = '#FF7E00';
								}
							}
							if(data.dataType.warnDown != null){
								let warnDown = Number(data.dataType.warnDown);
								if(value<=warnDown){
									data.colorTip = '#FF0000';
								}
							}
							if(data.dataType.warnUp != null){
								let warnUp = Number(data.dataType.warnUp);
								if(value<=warnUp){
									data.colorTip = '#FF0000';
								}
							}
						}
					}
				}
				
			},
			//将所选属性值push进看板数组this.dataBlock里
			dataBlockPush(){
				let ThisActive = this.ThisActive;
				for(let attrMoth of ThisActive.DeviceMoth){
					for(let attr of attrMoth.attrData){
						attr.DeviceId = attrMoth.DeviceId;
						attr.DeviceName = attrMoth.DeviceName;
						attr.DeviceCode = attrMoth.DeviceCode;
						this.dataBlock.push(attr)
					}
				}
				this.productFeatureGet();
			},
			//更新 获取物模型 判断内容及范围值
			productFeatureGet(){
				var dataBlock = this.dataBlock;
				let count = 0;
				let self = this;
				for(let pro of self.ThisActive.DeviceMoth){
					self.get('/ProductFeature/get',{
						code:pro.productCode
					}).then((res)=>{
						self.PropertyValue.push({
							productCode: pro.productCode,
							productList: JSON.parse(res.result).properties
						});
						count++;
						if(count == self.ThisActive.DeviceMoth.length){
							self.dataBlockChange();
						}
					})
				}
				
			},
			dataBlockChange(){
				for(let attrData of this.dataBlock){//循环选中的属性
					for(let propList of this.PropertyValue){//循环接口返回的所需要的物模型列表
						for(let prop of propList.productList){//循环物模型列表中的属性列表
							if(attrData.id.split('-')[0] == prop.identifier){//如果选中属性id==物模型列表中属性列表的属性id
								attrData.accessMode = prop.accessMode
								attrData.type = prop.dataType.type;
								if(prop.dataType.type == 'enum' || prop.dataType.type == 'bool'){
									attrData.selectData = [];
									Object.keys(prop.dataType.specs).forEach(function(key){
	                                    let devObj ={};
	                                    devObj.id = key;
	                                    if(attrData.value == devObj.id){
	                                    	devObj.mark = true
	                                    }else{
	                                    	devObj.mark = false
	                                    }
	                                    devObj.name = prop.dataType.specs[key];
	                                    attrData.selectData.push(devObj);
	                                });
								}else{
									attrData.specs = prop.dataType.specs;
									if(prop.dataType.type == 'int'){
										attrData.dataType = prop.dataType;
										let value = Number(attrData.value)
										attrData.colorTip = '#282828';
										if(prop.dataType.errorDown != null){
											let errorDown = Number(prop.dataType.errorDown);
											if(value<=errorDown){
												attrData.colorTip = '#FF7E00';
											}
										}
										if(prop.dataType.errorUp != null){
											let errorUp = Number(prop.dataType.errorUp);
											if(value>=errorUp){
												attrData.colorTip = '#FF7E00';
											}
										}
										if(prop.dataType.warnDown != null){
											let warnDown = Number(prop.dataType.warnDown);
											if(value<=warnDown){
												attrData.colorTip = '#FF0000';
											}
										}
										if(prop.dataType.warnUp != null){
											let warnUp = Number(prop.dataType.warnUp);
											if(value<=warnUp){
												attrData.colorTip = '#FF0000';
											}
										}
									}
								}
								
							}
						}
					}
				}
				this.$forceUpdate()/*强制刷新 略略略*/
			},
			close() {
				this.$parent.Addrobot(this.index);
			},
			ShowEdit(item,type) {
				
				if(type == 'img'){
					let itemNew = {};
					let ThisActive = this.ThisActive;
					itemNew.id = item.identifier;
					itemNew.name = item.name;
					itemNew.unit = item.dataType.specs.unit;
					itemNew.unitName = item.dataType.specs.unitName;
					itemNew.value = item.value;
					itemNew.DeviceId = ThisActive.DeviceId;
					itemNew.DeviceCode = ThisActive.DeviceCode;
					itemNew.accessMode = item.accessMode;
					itemNew.type = item.dataType.type;
					itemNew.specs = item.dataType.specs;
					itemNew.dataType = item.dataType;
					itemNew.colorTip = item.colorTip;
					this.MdfClassify(itemNew);
				}else if(type == 'Divspan'){
					this.MdfClassify(item,type);
				}
			},
			MdfClassify(item) {
				var self = this;
				if(this.$refs.mdfClassify.$el.style.display == "" || this.$refs.mdfClassify.$el.style.display == "none") {
					this.$refs.mdfClassify.binding(item);
					this.$refs.mdfClassify.$el.style.display = "block";
					setTimeout(function() {
						self.$refs.mdfClassify.$el.style.opacity = 1;
						self.$refs.mdfClassify.$children[0].$el.style.top = 0 + 'px';
					}, 50)
				} else {
					this.$refs.mdfClassify.$el.style.opacity = 0;
					self.$refs.mdfClassify.$children[0].$el.style.top = -50 + 'px';
					setTimeout(function() {
						self.$refs.mdfClassify.$el.style.display = "none";
					}, 100)
				}
			},
			attrChoice() {
				var self = this;
				if(this.$refs.attrChoice.$el.style.display == "" || this.$refs.attrChoice.$el.style.display == "none") {
					this.$refs.attrChoice.binding(this.dataBlock,this.ThisActive);
					this.$refs.attrChoice.$el.style.display = "block";
					setTimeout(function() {
						self.$refs.attrChoice.$el.style.opacity = 1;
						self.$refs.attrChoice.$children[0].$el.style.top = 0 + 'px';
					}, 50)
				} else {
					this.$refs.attrChoice.$el.style.opacity = 0;
					self.$refs.attrChoice.$children[0].$el.style.top = -50 + 'px';
					setTimeout(function() {
						self.$refs.attrChoice.$el.style.display = "none";
					}, 100)
				}
			},
		}
	}
</script>

<style scoped>
	.el-attrDiy .el-select-dropdown__item.selected{
		color: #5087e4;
		font-weight: unset;
	}
	.el-attrDiy .el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
		background-color: #F5F7FA;
	}
	.box_content>>>.el-input .el-input__icon{
		    height: 40px;
    width: 25px;
	}
	.box_content>>>.el-input__inner{
		border: 0px;
	}
	.box_content>>>.el-input{
		margin-left: 38px;
		width: 75%;
	}
	.attr_body {
		height: 560px;
		position: relative;
	}
	
	.box_content>>>.el-switch.is-checked .el-switch__core::after {
		left: 100%;
		margin-left: -17px;
	}
	
	.box_content>>>.el-switch__core:after {
		width: 18px;
		height: 18px;
		top: 0px;
		left: 0px;
	}
	
	.box_content>>>.el-switch__core {
		border: 1px solid #757575;
		background: #141414;
	}
	
	.box_content>>>.el-switch.is-checked .el-switch__core {
		border-color: #2571EF;
		background-color: #2571EF;
	}
	
	.content_value {
		float: right;
		max-width: 95px;
		margin-right: 15px !important;
	}
	
	.content_config {
		float: right;
		max-width: 66px;
		cursor: pointer;
		line-height: 19px;
		padding: 2px 12px;
		border-radius: 12px;
		background-color: #5087e4;
		color: #fff;
		margin-top: 13px;
		font-size: 12px;
	}
	
	.content_Mark {
		float: right;
		max-width: 66px;
		cursor: pointer;
		line-height: 19px;
		padding: 2px 12px;
		border-radius: 12px;
		color: #282828;
		margin-top: 13px;
		font-size: 12px;
		transition: .1s;
	}
	
	.content_Mark.active {
		color: #fff;
		background-color: #5087e4;
	}
	
	.box_content {
		float: right;
		width: 120px;
	}
	
	.box_name {
		float: left;
		width: 70px;
	}
	.box_name_Img {
		float: left;
		width: 100px;
	}
	.box_nameDevice{
		float: left;
		width: 60px;
	}
	.history-data {
		float: right;
		color: #5087E4;
		font-size: 14px;
		margin-top: 24px;
		cursor: context-menu;
		cursor: pointer;
		position: relative;
		right: 22px;
	}
	
	.data-lab:nth-last-child(1),
	.data-lab:nth-last-child(2) {
		border-bottom: 1px solid #e6e6e6;
	}
	
	.data-lab {
		width: 288px;
		text-align: left;
		padding: 0 14px;
		line-height: 48px;
		-webkit-box-sizing: border-box;
		/* box-sizing: border-box; */
		font-size: 14px;
		border: 1px solid #e6e6e6;
		border-bottom: 0;
		float: left;
	}
	
	.fileImgShow {
		background-position: left top;
		background-repeat: no-repeat;
	}
	
	.connectPoint {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		width: 10px;
		height: 10px;
		background-color: #5087E4;
		border-radius: 50%;
		line-height: 11px;
		font-size: 12px;
		color: #fff;
		margin-left: -5px;
		margin-top: -5px;
	}
	
	.connectPoint div {
		transform: scale(.8);
		position: relative;
		left: 0px;
	}
	
	.overAuto {
		width: 100%;
		overflow-y: auto;
		overflow-x: hidden;
		height: 560px;
	}
	
	.overAuto .data-lab:nth-child(odd) {
		margin-right: 35px;
	}
	
	.blueSpan {
		cursor: pointer !important;
		color: #5087E4 !important;
	}
	
	.el-form>>>.bottom__ .el-select .el-input.el-input--suffix i {
		line-height: 34px;
	}
	
	.el-form>>>.bottom__ .el-select .el-input.el-input--suffix input {
		height: 34px;
		border-radius: 0;
		line-height: 34px;
		/* padding: 0 !important; */
		margin: 0 !important;
	}
	
	.el-form>>>.bottom__ .el-select .el-input.el-input--suffix {
		height: 34px;
	}
	
	.el-form>>>.bottom__ .el-select {
		width: 140px;
		height: 34px;
		float: left;
	}
	
	.top_box .ljd_name {
		margin-right: 36px !important;
	}
	
	.top_box .ljd_name,
	.ljd_cx {
		line-height: 34px;
		font-size: 14px;
		margin-right: 13px;
		float: left;
	}
	
	.top_box .ljd_sc {
		line-height: 34px;
		font-size: 14px;
		float: left;
		margin-left: 12px;
	}
	
	.el-form>>>.el-input-number__decrease,
	.el-form>>>.el-input-number__increase {
		display: none;
	}
	
	.el-form>>>.el-input-number {
		float: left;
		width: 57px;
		margin-top: -2px;
	}
	
	.errorLight {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
	}
	
	.el-form>>>.el-textarea__inner {
		border-radius: 0px !important;
	}
	
	.top_content .title {
		float: left;
		width: 60px;
		line-height: 34px;
	}
	
	.top_content .positionXY {
		float: left;
		width: 77px;
		margin-right: 21px;
	}
	
	.top_content .positionXY span {
		float: left;
		line-height: 34px;
		margin-right: 12px;
	}
	
	.el-form>>>.top_content .positionXY .el-input {
		float: left;
		width: 57px;
		height: 34px;
	}
	
	.el-form>>>.top_content .positionXY .el-input input {
		height: 34px;
		border-radius: 0px;
		text-align: center;
		width: 100%;
		padding: 0;
	}
	
	.el-form>>>.el-checkbox {
		float: left;
		width: 30%;
		line-height: 34px;
	}
	
	.top_content.active {
		color: #393939;
	}
	
	.top_content {
		width: 70%;
		float: left;
		color: #C2C2C2;
		transition: .3s;
	}
	
	.bottom__ .top_content {
		width: 220px;
		float: left;
		color: #393939;
		margin-left: 25px;
	}
	
	.bottom__ .top_content .title {
		width: 45px;
	}
	
	.top_box {
		width: 100%;
		float: left;
		margin-bottom: 8px;
		text-align: left;
	}
	
	.top__ p {
		/*margin-top: 25px;*/
		margin-bottom: 10px;
		color: #2F3A4E;
		font-size: 13px;
		text-align: left;
		float: left;
	}
	
	.bottom__ p {
		/*margin-top: 25px;*/
		margin-bottom: 10px;
		color: #2F3A4E;
		font-size: 13px;
		text-align: left;
		float: left;
	}
	
	.content_right .right_ {
		float: left;
		width: 100%;
		position: relative;
	}
	
	.top__ {
		margin-top: 25px;
	}
	
	.bottom__ {
		margin-top: 45px;
	}
	
	.content_right {
		width: 553px;
		float: left;
		position: relative;
	}
	
	.el-form-item__errorMy.active {
		opacity: 1;
		transform: scaleY(1);
	}
	
	.el-form-item__errorMy {
		color: #F56C6C;
		font-size: 12px;
		line-height: 1;
		padding-top: 4px;
		position: absolute;
		top: 100%;
		left: 0;
		transition: .3s;
		opacity: 0;
		transform: scaleY(0);
	}
	
	.classifyOpa {
		font-weight: unset !important;
	}
	
	.test-box {
		position: absolute;
		width: 20px;
		height: 20px;
		background-color: red;
		border-radius: 50%;
	}
	
	.fileImgShow {
		position: absolute;
		left: -21px;
		right: 0;
		bottom: 0;
		top: 0px;
		margin: auto;
		width: 173px;
		height: 197px;
	}
	
	.position_xyzImg {
		position: absolute;
		right: 4px;
		bottom: 11px;
	}
	
	.position_xyImg {
		position: absolute;
		left: 4px;
		top: 4px;
	}
	
	.position_body {
		position: relative;
		width: 292px;
		background: rgba(245, 245, 245, 1);
		height: 237px;
		cursor: pointer;
		float: left;
		margin-top: 3px;
		overflow: hidden;
	}
	
	.file_img p {
		color: #2c3e50;
		text-align: left;
		line-height: 17px;
		margin-bottom: 9px;
		font-size: 14px;
	}
	
	.file_img .file_img_span {
		cursor: pointer;
		color: #5087E4;
		top: 0;
		position: relative;
		float: left;
		width: 100%;
		text-align: left;
		left: 45px;
		top: 2.5px;
	}
	
	.file_img {
		float: left;
		width: 100%;
		/* padding-top: 24px; */
		margin-top: -40px;
	}
	
	.content_left {
		float: left;
		width: 582px;
		position: relative;
	}
	
	.form-mdfpwd {
		width: 100vw;
		height: calc(100vh + 140px);
		display: none;
		background: rgba(0, 0, 0, .4);
		position: absolute;
		top: -10px;
		bottom: 0;
		left: -320px;
		right: 0;
		z-index: 200;
		margin: auto;
		opacity: 0;
		transition: .2s;
	}
	
	.el-form {
		display: block;
		width: 613px;
		height: 630px;
		position: absolute;
		margin: auto;
		left: 0;
		right: 0;
		bottom: 0;
		top: -50px;
		transition: .2s;
		background-color: #fff;
		border-radius: 1px;
		padding-left: 34px;
		padding-right: 30px;
	}
	
	.pwdhead {
		width: 100%;
		height: 63px;
		/*border-bottom: 1px solid #efefef;*/
	}
	
	.pwdhead .pwdtitle {
		float: left;
		color: #2F3A4E;
		font-size: 15px;
		margin-left: -2px;
		margin-top: 22px;
		cursor: context-menu;
	}
	
	.pwdhead .closediv {
		float: right;
		position: relative;
		margin-right: -9px;
		margin-top: 18px;
		width: 2rem;
		height: 2rem;
		cursor: pointer;
	}
	
	.pwdhead .close {
		float: right;
		position: relative;
		width: 0.1em;
		height: 1.3em;
		background: #333;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		display: inline-block;
		top: 8px;
		right: 15px;
	}
	
	.pwdhead .close:after {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 0.1em;
		height: 1.3em;
		background: #333;
		-webkit-transform: rotate(270deg);
		-moz-transform: rotate(270deg);
		-o-transform: rotate(270deg);
		-ms-transform: rotate(270deg);
		transform: rotate(270deg);
	}
	
	.el-form-item {
		margin: 0;
		/* padding-left: 13px; */
		padding-top: 24px;
	}
	
	.el-form-item>>>.el-form-item__label {
		float: left;
		width: 100%;
		color: #2c3e50;
		text-align: left;
		line-height: 17px;
		margin-bottom: 9px;
	}
	
	.el-form-item>>>.el-form-item__content {
		float: left;
		width: 494px;
	}
	
	.el-form-item>>>.el-input__inner {
		padding: 0 !important;
		margin: 0 !important;
		color: #2F3030 !important;
		background: #fff !important;
		text-indent: 15px !important;
		/*border: 1px solid rgba(222, 222, 222, 1) !important;*/
		border-radius: 0px;
	}
	
	.el-form>>>.ely-button {
		background-color: #5087E4;
		color: #fff;
		width: 86px;
		letter-spacing: 1px;
		margin-top: 18px;
		font-size: 13px;
		cursor: pointer;
		border: 0;
		border-radius: 2px;
		height: 34px;
		line-height: 33px;
		position: absolute;
		left: 0px;
		right: 0;
		bottom: 28px;
		margin: auto;
		margin-top: 23px;
	}
	.el-form>>>.el-select {
		width: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/MapEditor/canvas/Draggable/draggable/AttrBlackboardCan.vue